// removed by extract-text-webpack-plugin
module.exports = {"input-count-number":"input-count-number","wrap-input-number":"wrap-input-number","next-value":"next-value","prev-value":"prev-value","input-count-value":"input-count-value"};


//////////////////
// WEBPACK FOOTER
// ./components/danangtrade-forms/common/_InputCountNumber.scss
// module id = ./components/danangtrade-forms/common/_InputCountNumber.scss
// module chunks = 0